module.exports = __webpack_public_path__ + "img/Tracicionales 3.2bddbc26.jpg";